import style from "../../../../assets/scss/common/modal/leaveModal.module.scss";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

interface Args{
    setIsAllAgreementSelected: (_: boolean) => void;
    errorMessage: string;
    setErrorMessage: (_:string) => void;
}
export function LeaveAgreementField({setIsAllAgreementSelected, errorMessage, setErrorMessage}: Args) {
    const { t } = useTranslation("userInfo");
    const [voucherAgreement, setVoucherAgreement] = useState(false);
    const [affiliationAgreement, setAffiliationAgreement] = useState(false);
    const [sameAccountAgreement, setSameAccountAgreement] = useState(false);
    const [informationAgreement, setInformationAgreement] = useState(false);
    const [selectAll, setSelectAll] = useState(false);



    const selectAgreeWrappers = [
        {
            content: t('leave.step1.item1'),
            isAgreed: voucherAgreement,
            setAgreement: setVoucherAgreement,
            isAllSelectButton: false,
        },
        {
            content: t('leave.step1.item2'),
            isAgreed: affiliationAgreement,
            setAgreement: setAffiliationAgreement,
            isAllSelectButton: false,
        },
        {
            content: t('leave.step1.item3'),
            isAgreed: sameAccountAgreement,
            setAgreement: setSameAccountAgreement,
            isAllSelectButton: false,
        },
        {
            content: t('leave.step1.item4'),
            isAgreed: informationAgreement,
            setAgreement: setInformationAgreement,
            isAllSelectButton: false,
        },
        {
            content: t('leave.step1.selectAll'),
            isAgreed: selectAll,
            setAgreement: setSelectAll,
            isAllSelectButton: true,
        },
    ];

    useEffect(() => {
        setIsAllAgreementSelected(voucherAgreement && affiliationAgreement && sameAccountAgreement && informationAgreement)
        setSelectAll(voucherAgreement && affiliationAgreement && sameAccountAgreement && informationAgreement)
        setErrorMessage('')

        // eslint-disable-next-line
    }, [voucherAgreement, affiliationAgreement, sameAccountAgreement, informationAgreement]);

    const handleTotalAgreement = () => {
        if (voucherAgreement && affiliationAgreement && sameAccountAgreement && informationAgreement) {
            setVoucherAgreement(false)
            setAffiliationAgreement(false)
            setSameAccountAgreement(false)
            setInformationAgreement(false)
        } else {
            // 하나라도 false일 경우 모두 true로 설정
            setVoucherAgreement(true)
            setAffiliationAgreement(true)
            setSameAccountAgreement(true)
            setInformationAgreement(true)
        }
    }
    return(
        <>
            <div className={style.leaveAgreementWrapper}>
                <div className={style.leaveAgreementContentWrapper}>
                    {selectAgreeWrappers.map((wrapper, index) => (
                        <div className={style.agreementContent} key={index}
                             onClick={() => {
                                 wrapper.setAgreement(!wrapper.isAgreed);
                                 if (wrapper.isAllSelectButton) {
                                     handleTotalAgreement();
                                 }
                             }}>
                            <div className={`${style.agreementCheckImg} ${wrapper.isAgreed ? style.selected : ''}`}/>
                            <div className={style.agreementTextWrapper}>
                                <span className={`${style.agreementText} ${wrapper.isAllSelectButton ? style.bold : ''}`}>
                                    {wrapper.content}
                                </span>
                            </div>
                        </div>
                    ))}
                    {errorMessage && (
                        <div className={style.errorMessageWrapper}>
                            <span className={style.message}>{errorMessage}</span>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}